<div class="p-dialog-header px-0">
    <div class="col-12 p-dialog-title row">
        <span class="text-center ">Please verify that the following parameters will be modified.</span>
        <span class=" text-center">Once applied, the campaign data cannot be reverted.</span>
    </div>
    <!-- <div class="p-dialog-header-icons">
      <button (click)="cancel()" class="p-dialog-header-icon p-dialog-header-maximize p-link" type="button">
        <span class="p-dialog-header-close-icon pi pi-times"></span>
      </button>
    </div> -->
  </div>
<div class="mt-2 p-dialog-body grid p-fluid">
    <div class="col-12 row">
        <ng-container *ngFor="let item of result">
            <div class="col-12 row mt-2" *ngIf="item.show">
                <div class="col-3">{{item.field}}</div>
                <div class="col-4">
                    {{item.old}}
                </div>
                <div class="col-1"><span><i class="pi pi-angle-right"></i></span></div>
                <div class="col-4">
                    {{item.new}}
                </div>
            </div>
        </ng-container>
    </div>
    <hr>
    <div class="accent-color">
      <mat-radio-group aria-label="Select an option" color="accent" [(ngModel)]="sendOrNot">
        <mat-radio-button [value]="0" checked>Do not Send Communication Emails</mat-radio-button>
        <br>
        <mat-radio-button [value]="1" class="mt-3">Send Communication Emails</mat-radio-button>
      </mat-radio-group>
      <div class="ms-4 mail-send-opts" [class.expanded-options]="sendOrNot">
        <mat-checkbox
          [indeterminate]="setAllChecked()"
          [checked]="isSendAll"
          (change)="setAll($event.checked)"
          class="mt-2"
          >{{withTargetPersonChanged ? mailLabel.targetUser : mailLabel.dataChanges}}</mat-checkbox>
        <div class="ms-4">
          <div *ngFor="let task of sendMailOptions.tasks; first as f" [class.mt-1]="f">
            <mat-checkbox
              [(ngModel)]="task.checked"
              (ngModelChange)="updateAllComplete()"
              class="mt-2"
            >{{task.label}}</mat-checkbox>
          </div>
        </div>
        <button class="me-2" style="color: #EE6B9A" mat-button (click)="openPreviewEmailTemplateWithDataChanged()">Preview Email</button>
        <ng-container *ngIf="withTargetPersonChanged">
          <br>
          <mat-checkbox class="mt-3" [(ngModel)]="sendMailOptions.sendToNewTargetAll.checked">{{sendMailOptions.sendToNewTargetAll.label}}</mat-checkbox>
          <br>
          <button class="me-2" style="color: #EE6B9A" mat-button (click)="openPreviewEmailTemplateWithTargetChanged()">Preview Email</button>
        </ng-container>

      </div>
    </div>

  <hr>
    <div class="row mt-3">
        <div class="dialog__footer d-flex justify-content-end">
            <button type="button" class="btn btn-transparent rounded mr-2" (click)="cancel()">
                Cancel
            </button>

            <button class="btn btn-red rounded ml-2" type="button" (click)="save()">
                Save
            </button>
        </div>

    </div>
</div>
